<div class="row-details">
  <div class="details-body">
    <div class="detail-row order-items-header">
      <span class="detail-label">Order Items</span>
      
      <div class="additional-info-inline">
        <div class="info-item">
          <span class="info-label">Net Weight</span>
          <span class="info-value">{{ order.totalWeight | number: '1.1-1' }}kg</span>
        </div>
        <span class="info-separator">|</span>
        <div class="info-item">
          <span class="info-label">Gross Weight</span>
          <span class="info-value">{{ order.totalWeight | number: '1.1-1' }}kg</span>
        </div>
        <span class="info-separator">|</span>
        <div class="info-item">
          <span class="info-label">CBM</span>
          <span class="info-value">{{ order.totalCBM | number: '1.1-1' }} CBM</span>
        </div>
      </div>
    </div>

    <div class="detail-row">
      <div class="order-items-section">
        <hmt-job-plan-order-list-items 
          [orders]="visibleShipmentOrders"
          [orderSelected]="orderSelected"
          [hideCheckboxes]="hideCheckboxes"
          (selectionChanged)="onSelectionChanged($event)"
          (selectOrderItem)="onItemSelected($event)"
          (quantityChanged)="onQuantityChanged($event)">
        </hmt-job-plan-order-list-items>
      </div>
    </div>
  </div>

  <!-- Window Cards Section -->
  <hmt-job-plan-window-cards [order]="order"></hmt-job-plan-window-cards>
</div>

